<template>
  <IcdInput
    :label="component.label"
    :value="value"
    item-text="histology_behavior_description"
    item-value="histology_behavior"
    search-index="codes_o_histology"
    @input="$emit('input', $event)"
  />
</template>

<script>
import * as algolia from '../../../services/algolia.js'
import IcdInput from '../../../components/inputs/IcdInput.vue'
export default {
  components: {
    IcdInput
  },
  props: {
    value: { type: String, default: '' },
    component: { type: Object },
    diagnosisMorphology: { type: String, default: () => '' }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null
    }
  },
  computed: {
    icdoCode() {
      const icdocode = this.items.find(
        ({ histology_behavior_description }) =>
          histology_behavior_description == this.value
      )
      return icdocode ? icdocode.histology_behavior : ''
    }
  },

  watch: {
    search(newval) {
      if (newval && newval !== this.value) {
        this.items = []
        this.fetchItems(newval)
      }
    }
  },

  created() {
    if (this.value) {
      this.search = this.value
    }
  },
  methods: {
    async fetchItems(query = '') {
      if (!query.trim()) {
        return
      }
      this.loading = true
      try {
        const data = await algolia.search(
          query,
          'codes_o_histology',
          this.$store.getters.accessToken
        )
        this.items = data.map(item => ({
          histology_behavior_description: item.histology_behavior_description
        }))
      } catch (err) {
        console.error(err)
        this.$store.dispatch('showErrorSnackbar', 'Algo deu errado')
      }

      this.loading = false
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
